import React from 'react'
import LazyLoad from 'react-lazyload'

import { useSupportsWebp } from 'src/hooks/useSupportsWebp'

import style from './cover-image.css'
import { eventClicked } from './tracking'

export const CoverImage = ({ coverImage, url, props }) => {
  const supportsWebp = useSupportsWebp()

  let inlineStyle = {}
  if (supportsWebp !== null) {
    inlineStyle = { backgroundImage: `url('${supportsWebp ? coverImage.webpUrl : coverImage.url}')` }
  }

  return (
    <a href={url} onClick={() => eventClicked(props)}>
      <LazyLoad
        once
        offset={200}
        placeholder={<div className={style.container} />}
      >
        <div className={style.container} style={inlineStyle} />
      </LazyLoad>
    </a>
  )
}
